import { TranslateUnauthenticatedPipe } from '../../filters/translate-unauthenticated.pipe';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { ItemFormErrorWithTranslatorComponent } from '../../components/item-form-error-with-translator/item-form-error-with-translator.component';
import { Component, OnDestroy, OnInit, inject, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { SiffiLanguagePickerComponent } from '../../components/siffi-language-picker/siffi-language-picker.component';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import BusinessRestServices from '../../services/business-rest.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import DialogServices from '../../services/dialog.service';
import AppLanguageService from '../../services/app-language.service';
import { Subscription } from 'rxjs';
import {
	ModalSafetyResultsIndividualComponent
} from '../../components/modal-safety-results-individual/modal-safety-results-individual.component';

declare const mdqstnr: any;

@Component({
	standalone: true,
	selector: 'survey',
	templateUrl: './survey.component.html',
	imports: [
		CommonModule, TranslateUnauthenticatedPipe, ItemErrorComponent, RouterLink,
		ItemFormErrorWithTranslatorComponent, FormsModule, LoaderOverlayComponent,
		SiffiLanguagePickerComponent
	]
})
export default class SurveyView implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private session: Session = inject(Session);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private dialogServices: DialogServices = inject(DialogServices);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);

	vm: any = undefined;
	private titleSubscription: Subscription = undefined;
	private questionnairePluginInitialized: boolean = false;

	constructor(private ngZone: NgZone) {
		this.vm = this;
	}

	ngOnInit() {
		this.vm.loading = true;
		
		var queryParams: any = this.angularRoutingHelperService.getQueryParams();
		this.determineLocation(queryParams);
		
		this.vm.appName = (this.vm.origin === 'siffi.com') ? 'Siffi' : 'Minudoc';
		this.vm.token = queryParams['token'];
		this.vm.isLanguageMenuOpen = false;
		this.vm.locale = queryParams['locale'] || 'en_GB';
		const loginOrigin = this.vm.origin === 'minudoc.ee' ? 'minudoc.ee' : 'siffi.com';
		this.vm.counsellingLoginUrl = this.config.getPublicWebUrlUsingDomain(loginOrigin, true)
			+ '/app/#/login?locale=' + encodeURIComponent(this.vm.locale)
			+ '&origin=' + encodeURIComponent(loginOrigin);
		this.vm.localeParams = this.vm.locale ? { locale: this.vm.locale } : undefined;
		window.sessionStorage.setItem("locale", this.vm.locale);
		this.vm.locales = this.appLanguageService.getLanguagesByOrigin(this.vm.origin);
	    var currentSession = this.session.getSession();
		this.vm.isAuthenticated = !!currentSession;
		
		this.vm.environment = this.config.getSettings().ENVIRONMENT.toLowerCase();
		if (this.vm.environment === "{{environment}}") {
			if (this.config.getRestUrl().indexOf("devel") > -1) {
		    	this.vm.environment = "devel";
			} else {
				this.vm.environment = "test";
			}
		}
		
		this.vm.language = window.navigator.language;
		this.vm.lang = window.sessionStorage.getItem("locale") || 'et_EE' ;
		this.vm.logoSuffix = this.vm.lang.split("_")[0];
		
		if (this.vm.locale === 'en_GB' || this.vm.locale === 'et_EE' || this.vm.locale === 'ru_RU' || this.vm.locale === 'fi_FI') {
		    this.vm.appLogoLang = this.vm.locale.split("_")[0];
		} else {
		    this.vm.appLogoLang = 'en';
		}
		if (this.vm.origin === 'siffi.com') {
		    this.vm.androidLink = 'https://play.google.com/store/apps/details?id=com.siffi&hl=' + this.vm.appLogoLang;
		    this.vm.iosLink = 'https://apps.apple.com/app/siffi/id1629846508?platform=iphone';
		} else {
		    this.vm.androidLink = 'https://play.google.com/store/apps/details?id=ee.minudoc&hl=' + this.vm.appLogoLang;
		    this.vm.iosLink = 'https://apps.apple.com/app/minudoc/id1465732931?platform=iphone';
		}
		
		this.vm.setLocale = this.setLocale;
		this.vm.navigateToRoot = this.navigateToRoot;
		this.vm.reload = this.navigateToRoot;
		this.vm.openSurvey = this.openSurvey;
		this.vm.getEvaluations = this.getEvaluations;
		this.vm.getSurveyStartLabel = this.getSurveyStartLabel;
		this.vm.getLocaleOption = this.getLocaleOption;
		this.vm.getDisplayTextForTranslatable = this.getDisplayTextForTranslatable;
		this.vm.getComplianceQuestionSections = this.getComplianceQuestionSections;
		this.vm.getComplianceQuestions = this.getComplianceQuestions;
		this.vm.getComplianceQuestionCount = this.getComplianceQuestionCount;
		this.vm.getCurrentComplianceQuestionGroup = this.getCurrentComplianceQuestionGroup;
		this.vm.getComplianceSectionProgress = this.getComplianceSectionProgress;
		this.vm.isFirstComplianceSection = this.isFirstComplianceSection;
		this.vm.isLastComplianceSection = this.isLastComplianceSection;
		this.vm.previousComplianceSection = this.previousComplianceSection;
		this.vm.nextComplianceSection = this.nextComplianceSection;
		this.vm.isComplianceMultiSelect = this.isComplianceMultiSelect;
		this.vm.isComplianceAnswered = this.isComplianceAnswered;
		this.vm.isComplianceSelected = this.isComplianceSelected;
		this.vm.setComplianceAnswer = this.setComplianceAnswer;
		this.vm.toggleComplianceAnswer = this.toggleComplianceAnswer;
		this.vm.setComplianceAnswerValue = this.setComplianceAnswerValue;
		this.vm.getComplianceAnswerValue = this.getComplianceAnswerValue;
		this.vm.submitComplianceSurvey = this.submitComplianceSurvey;
		this.vm.closeComplianceSurvey = this.closeComplianceSurvey;

		var scriptSrc = 'https://apps-content.s3.eu-west-1.amazonaws.com/questionnaire/questionnaire-3.0.4.js';
		this.initQuestionnairePlugin(window, document, 'script', 'mdqstnr', scriptSrc);
		
		this.handleViewInit(queryParams);
		
		this.titleSubscription = this.angularFilterHelperService.watchDocumentTitleUnauthenticated('Surveys.Survey_Title');
	}

	ngOnDestroy() {
		if (this.titleSubscription) {
			this.titleSubscription.unsubscribe();
		}
	}
	
	determineLocation(queryParams) {
		var host: any = window.location.hostname;
		var origin: any = queryParams['origin'] || (host.includes('minudoc') ? 'minudoc.ee' : 'siffi.com');
		this.vm.origin = origin;
		if (host.includes("siffi")) {
			this.vm.origin= origin || "siffi.com";
			this.vm.product = "SIFFI";
			this.vm.headerClass = "o-container c-container";
		} else if (host.includes("minudoc")) {
			this.vm.origin= origin || "minudoc.ee";
			var url: any = window.location.href;
			this.vm.product = url.includes("eelvisiit") ? "PREVISIT" : "MINUDOC";
			this.vm.headerClass = "";
		}
	}
	
	navigateToRoot($event) {
		$event.preventDefault();
		window.location.href = this.config.getPublicWebHomeUrl(this.vm.origin, this.vm.locale);
	}
	
	setLocale(locale) {
		this.angularRoutingHelperService.setQueryParam('locale', locale);
		setTimeout(() => {
			window.location.reload();
		}, 300);
	}

	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}
	
	handleViewInit(queryParams) {
	    var token = queryParams['token'];
		this.vm.requestId = queryParams['requestId'];
		this.vm.userId = queryParams['userId'];
		
		this.businessRestServices.checkTokenValidity({token: token, language: this.vm.locale},
			(response) => {
				const parsedResponse = JSON.parse(response.body);
				this.vm.isAvailable = response.status === 200;
				this.vm.survey = parsedResponse;
				this.vm.codeName = this.vm.survey.codeName;
				this.vm.isComplianceAssessmentSurvey = this.isComplianceAssessment(this.vm.codeName);
				if (!this.vm.isComplianceAssessmentSurvey) {
					this.initQuestionnairePlugin(window, document, 'script', 'mdqstnr', this.vm.questionnairePluginScriptSrc);
				}
				this.vm.loading = false;
			},
			(err) => {
				console.log(err);
				this.vm.isAvailable = false;
				if (err.status === 400 && err.error === "Survey completed") {
				    this.vm.showSurveyCompletedError = true;
				} else if (err.status === 400 && err.error === "Date is expired") {
				    this.vm.showDataExpiredError = true;
				} else {
				    this.vm.showLinkIsNotCorrectError = true;
				}
				this.vm.loading = false;
			}
		);
	}
	
	initQuestionnairePlugin(m, i, n, u, d, o?, c?) {
		if (this.questionnairePluginInitialized) return;
		this.questionnairePluginInitialized = true;
		m.MinudocObject = u, m.mdqstnr = m.mdqstnr || function() { (m.mdqstnr.q = m.mdqstnr.q || []).push(arguments) },
			o = i.createElement(n), c = i.getElementsByTagName(n)[0], o.id = u, o.src = d,
			o.async = 1, c.parentNode.insertBefore(o, c);
	}
	
	openSurvey() {
		if (this.vm.isComplianceAssessmentSurvey) {
			this.openComplianceSurvey();
			return;
		}
	    var questionnaireConfig: any = {
	        origin: this.vm.origin,
	        language: this.vm.locale,
	        codeName: this.vm.codeName,
	        environment: this.vm.environment,
	        closeModalAfterSubmit: true,
	        afterQuestionnaireSubmitHook: (userAnswerToken, userScore, questionnaire) => {
	            this.ngZone.run(() => {
	                var userScoreObject = JSON.parse(userScore);
	                var questionnaireJsonObject = JSON.parse(questionnaire);
					this.vm.showComplianceAssessmentCompletedMessage = this.isComplianceAssessment(questionnaireJsonObject.codeName || this.vm.codeName);
					if (this.vm.showComplianceAssessmentCompletedMessage) {
						this.updateQuestionnaireAnswerToken(userAnswerToken);
						return;
					}
					if(Object.keys(userScoreObject).length !== 0) {
						var maxValue = 0;
						var sum = 0;

						if (questionnaireJsonObject.questions && questionnaireJsonObject.evaluations) {
							console.log("ev1");
							this.vm.questionsObject = questionnaireJsonObject.questions;
							this.vm.evaluationsObject = questionnaireJsonObject.evaluations;

							this.vm.isMultipleQuestionnaire = false;

							maxValue = this.findSumOfMaxScores(this.vm.questionsObject);

							console.log("userScoreObject0", userScoreObject);
//							if (questionnaireJsonObject.codeName === 'DOM-SAFETY') {
//								const positionsToReverse = [0, 2, 4];//[1, 3, 5, 6];
//								const updatedScores = Object.entries(userScoreObject).map(([key, value], index) => {
//									console.log("key, value, index" +  key + " " + value + " " + index);
//									if (positionsToReverse.includes(index)) {
//										value = this.reverseScore(value);
//									}
//									return [key, value];
//								});
//
//								userScoreObject = Object.fromEntries(updatedScores);
//							}

							sum = this.getQuestionnaireScore(this.vm.questionsObject, userScoreObject);

							this.displayColorRanges(maxValue, sum, questionnaireJsonObject);
							var evaluationText = this.getEvaluations(this.vm.evaluationsObject, sum);
							this.displayEvaluations(evaluationText, questionnaireJsonObject, sum);

						} else {
							console.log("ev2");
							var children = questionnaireJsonObject.children;
							this.vm.isMultipleQuestionnaire = true;

							children.forEach((child) => {
								this.vm.questionsObject = child.questions;
								this.vm.evaluationsObject = child.evaluations;

								maxValue = this.findSumOfMaxScores(this.vm.questionsObject);
								sum = this.getQuestionnaireScore(this.vm.questionsObject, userScoreObject);

								var evaluationText = this.getEvaluations(this.vm.evaluationsObject, sum);
								this.displayEvaluations(evaluationText, child, sum);
								this.displayColorRanges(maxValue, sum, child);
							});
						}
						
						console.log("Sum", sum);
						console.log("evaluationsObject", this.vm.evaluationsObject);
						console.log("questionsObject", this.vm.questionsObject);
						console.log("userScoreObject", userScoreObject);
					} else {
						this.vm.showSubmittingMessage = true;
					}

					this.updateQuestionnaireAnswerToken(userAnswerToken);
	            });

	        }
	    };
		if (this.vm.requestId) {
			questionnaireConfig.requestId = parseInt(this.vm.requestId);
		}
		if (this.vm.userId) {
			questionnaireConfig.userId = parseInt(this.vm.userId);
		}
	    mdqstnr('init', questionnaireConfig);
	}

	openComplianceSurvey() {
		this.vm.complianceLoading = true;
		this.vm.complianceSubmitError = false;
		this.vm.complianceValidationError = false;
		this.vm.complianceAnswers = {};
		this.businessRestServices.getPublicQuestionnaire({ code: this.vm.codeName, language: this.vm.locale },
			(questionnaire) => {
				this.vm.complianceQuestionnaire = questionnaire;
				this.vm.currentComplianceSectionIndex = 0;
				this.vm.showComplianceSurvey = true;
				this.vm.complianceLoading = false;
			},
			(err) => {
				console.error('Error loading compliance questionnaire:', err);
				this.vm.complianceSubmitError = true;
				this.vm.complianceLoading = false;
			}
		);
	}

	closeComplianceSurvey() {
		this.vm.showComplianceSurvey = false;
		this.vm.complianceQuestionnaire = undefined;
		this.vm.complianceAnswers = {};
		this.vm.currentComplianceSectionIndex = 0;
	}

	getComplianceQuestions(questionnaire) {
		var questions = [];
		var groups = questionnaire && questionnaire.children && questionnaire.children.length ? questionnaire.children : (questionnaire ? [questionnaire] : []);
		groups.forEach((group) => {
			(group.questions || []).forEach((question) => {
				if (typeof question.answers !== 'undefined') questions.push(question);
			});
		});
		return questions;
	}

	getComplianceQuestionSections(questionnaire) {
		var sectionSizes = [8, 6, 8, 6, 4, 10];
		var sectionTitleKeys = [
			'Compliance_Assessment.Section_Work_Demands',
			'Compliance_Assessment.Section_Influence_Development',
			'Compliance_Assessment.Section_Leadership_Recognition',
			'Compliance_Assessment.Section_Work_Organisation',
			'Compliance_Assessment.Section_Offensive_Behaviour',
			'Compliance_Assessment.Section_Digital_Work'
		];
		var questions = this.getComplianceQuestions(questionnaire);
		var sections = [];
		var offset = 0;
		for (var i = 0; i < sectionSizes.length; i++) {
			var size = sectionSizes[i];
			var sectionQuestions = questions.slice(offset, offset + size);
			if (i === sectionSizes.length - 1 && questions.length > offset + size) {
				sectionQuestions = questions.slice(offset);
			}
			sections.push({
				titleKey: sectionTitleKeys[i],
				questions: sectionQuestions
			});
			offset += size;
		}
		return sections;
	}

	getComplianceQuestionCount() {
		return this.getComplianceQuestions(this.vm.complianceQuestionnaire).length;
	}

	getCurrentComplianceQuestionGroup() {
		var groups = this.getComplianceQuestionSections(this.vm.complianceQuestionnaire);
		return groups[this.vm.currentComplianceSectionIndex || 0];
	}

	getComplianceSectionProgress() {
		var groups = this.getComplianceQuestionSections(this.vm.complianceQuestionnaire);
		if (!groups.length) return '0%';
		return (((this.vm.currentComplianceSectionIndex || 0) + 1) * 100 / groups.length) + '%';
	}

	isFirstComplianceSection() {
		return !this.vm.currentComplianceSectionIndex;
	}

	isLastComplianceSection() {
		var groups = this.getComplianceQuestionSections(this.vm.complianceQuestionnaire);
		return (this.vm.currentComplianceSectionIndex || 0) >= groups.length - 1;
	}

	previousComplianceSection() {
		this.vm.complianceValidationError = false;
		this.vm.complianceInvalidQuestionIds = {};
		this.vm.currentComplianceSectionIndex = Math.max((this.vm.currentComplianceSectionIndex || 0) - 1, 0);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	nextComplianceSection() {
		if (!this.validateComplianceQuestions((this.getCurrentComplianceQuestionGroup() || {}).questions || [])) return;
		var groups = this.getComplianceQuestionSections(this.vm.complianceQuestionnaire);
		this.vm.currentComplianceSectionIndex = Math.min((this.vm.currentComplianceSectionIndex || 0) + 1, groups.length - 1);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	isComplianceMultiSelect(question) {
		return question && question.answers && question.answers.length > 6;
	}

	isComplianceAnswered(question) {
		var answer = this.vm.complianceAnswers && this.vm.complianceAnswers[question.id];
		if (!answer) return false;
		if (question.answerType === 'TEXT' || question.answerType === 'NUMBER') {
			return answer.value !== undefined && answer.value !== null && answer.value.toString().trim() !== '';
		}
		if (Array.isArray(answer.id)) return answer.id.length > 0;
		return answer.id !== undefined && answer.id !== null && answer.id !== '';
	}

	isComplianceSelected(question, answer) {
		var selected = this.vm.complianceAnswers && this.vm.complianceAnswers[question.id];
		if (!selected) return false;
		return Array.isArray(selected.id) ? selected.id.indexOf(answer.id) > -1 : selected.id === answer.id;
	}

	setComplianceAnswer(question, answer) {
		this.vm.complianceAnswers[question.id] = {
			id: answer.id,
			score: answer.score,
			values: this.vm.complianceAnswers[question.id] ? this.vm.complianceAnswers[question.id].values : {}
		};
	}

	toggleComplianceAnswer(question, answer, checked) {
		var current = this.vm.complianceAnswers[question.id] || { id: [], values: {} };
		var ids = Array.isArray(current.id) ? current.id.slice(0) : [];
		var index = ids.indexOf(answer.id);
		if (checked && index === -1) ids.push(answer.id);
		if (!checked && index > -1) ids.splice(index, 1);
		this.vm.complianceAnswers[question.id] = { id: ids, score: answer.score, values: current.values || {} };
	}

	setComplianceAnswerValue(question, answer, value) {
		var current = this.vm.complianceAnswers[question.id] || { id: answer.id, score: answer.score, values: {} };
		if (this.isComplianceMultiSelect(question)) {
			var ids = Array.isArray(current.id) ? current.id.slice(0) : [];
			if (ids.indexOf(answer.id) === -1) ids.push(answer.id);
			current.id = ids;
		} else {
			current.id = answer.id;
		}
		current.score = answer.score;
		current.value = value;
		current.values = current.values || {};
		current.values[answer.id] = value;
		this.vm.complianceAnswers[question.id] = current;
	}

	getComplianceAnswerValue(question, answer) {
		var current = this.vm.complianceAnswers && this.vm.complianceAnswers[question.id];
		if (!current) return '';
		return current.values && current.values[answer.id] ? current.values[answer.id] : current.value || '';
	}

	submitComplianceSurvey() {
		if (!this.validateComplianceQuestions(this.getComplianceQuestions(this.vm.complianceQuestionnaire))) return;

		var answerArray = [];
		for (var questionId in this.vm.complianceAnswers) {
			var answer = this.vm.complianceAnswers[questionId];
			var answerIds = Array.isArray(answer.id) ? answer.id : [answer.id];
			answerIds.forEach((answerId) => {
				answerArray.push({
					id: parseInt(answerId, 10),
					answerValue: answer.values && answer.values[answerId] ? answer.values[answerId] : answer.value || ''
				});
			});
		}
		answerArray = answerArray.filter((item) => item.id !== undefined && !isNaN(Number(item.id)));

		this.vm.complianceSubmitting = true;
		this.vm.complianceSubmitError = false;
		this.businessRestServices.submitPublicQuestionnaire({
				questionnaireId: this.vm.complianceQuestionnaire.id,
				language: this.vm.locale,
				requestId: this.vm.requestId,
				userId: this.vm.userId
			}, answerArray,
			(response) => {
				this.vm.showCompletedMessage = true;
				this.updateQuestionnaireAnswerToken(response.token);
				this.vm.complianceSubmitting = false;
				this.vm.showComplianceSurvey = false;
				this.vm.showComplianceAssessmentCompletedMessage = true;
			},
			(err) => {
				console.error('Error submitting compliance questionnaire:', err);
				this.vm.complianceSubmitError = true;
				this.vm.complianceSubmitting = false;
			}
		);
	}

	validateComplianceQuestions(questions) {
		this.vm.complianceInvalidQuestionIds = {};
		this.vm.complianceValidationError = false;
		for (var i = 0; i < questions.length; i++) {
			if (typeof questions[i].answers === 'undefined') continue;
			if (!this.isComplianceAnswered(questions[i])) {
				this.vm.complianceInvalidQuestionIds[questions[i].id] = true;
				this.vm.complianceValidationError = true;
			}
		}
		if (this.vm.complianceValidationError) {
			setTimeout(() => {
				var first = document.querySelector('.compliance-survey .question-error');
				if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 0);
			return false;
		}
		return true;
	}

	updateQuestionnaireAnswerToken(userAnswerToken) {
		this.businessRestServices.updateQuestionnaireAnswerToken({ token: this.vm.token, userAnswerToken: userAnswerToken },
			(response) => {
				this.vm.showCompletedMessage = response.status === 200;
			},
			(err) => {
				console.error('Error updating questionnaire answer token:', err);
				this.vm.showCompletedMessage = false;
			}
		);
	}

	isComplianceAssessment(codeName) {
		return (codeName || '').toString().toUpperCase().replace(/[\s-]+/g, '_') === 'COMPLIANCE_ASSESSMENT';
	}

	getLabel(value) {
	    if (value <= 20) return this.angularFilterHelperService.translateUnauthenticated('Surveys.Very_Low');
	    if (value <= 40) return this.angularFilterHelperService.translateUnauthenticated('Surveys.Low');
	    if (value <= 60) return this.angularFilterHelperService.translateUnauthenticated('Surveys.Medium');
	    if (value <= 80) return this.angularFilterHelperService.translateUnauthenticated('Surveys.High');
	    return this.angularFilterHelperService.translateUnauthenticated('Surveys.Very_High');
	}

	reverseScore(score): number {
		const reverseMapping = { 1: 5, 2: 4, 3: 3, 4: 2, 5: 1 };
		return reverseMapping[score] || score;
	}

	getSurveyStartLabel() {
		return this.angularFilterHelperService.translateUnauthenticated('Surveys.Start_Survey').replace('%s', this.vm.survey.translation ? this.vm.survey.translation.translationTextName : this.vm.survey.description);
	}

	findSumOfMaxScores(questions) {
	    var totalMaxScore = 0;

	    questions.forEach(function(question) {
	        var maxScore = -Infinity;
	        question.answers.forEach(function(answer)  {
	            if (answer.score > maxScore) {
	                maxScore = answer.score;
	            }
	        });
	        totalMaxScore += maxScore;
	    });

	    return totalMaxScore;
	}

	getQuestionnaireScore(q, userScore) {
	    var questionnaireScore = 0;
	    for (var l = 0; l < q.length; l++) {
	        var questionScore = userScore[q[l].id];
	        questionnaireScore = questionnaireScore + questionScore;
	    }
	    return questionnaireScore;
	}

	getEvaluations(evaluations, questionnaireScore) {
	    var evaluationText;
	    var evaluationRange;

	    for (var m = 0; m < evaluations.length; m++) {
	        var qEvaluation = evaluations[m];
	        if (questionnaireScore >= qEvaluation.scoreRangeStart && questionnaireScore <= qEvaluation.scoreRangeEnd) {
	            evaluationRange = questionnaireScore;
	            evaluationText = this.getDisplayTextForTranslatable(qEvaluation);
	        }
	    }
	    return evaluationText;
	}

	getDisplayTextForTranslatable(toBeTranslated) {
	    if (toBeTranslated.translation) {
	        return toBeTranslated.translation.translationText;
	    } else {
	        if (toBeTranslated.defaultText) {
	            return toBeTranslated.defaultText;
	        } else if (toBeTranslated.description) {
	            return toBeTranslated.description;
	        } else {
	            return "-";
	        }
	    }
	}

	getEvaluationsForSafetySurvey(sum) {
		if(sum > 0 && sum <= 10) {
			return this.angularFilterHelperService.translateUnauthenticated('Surveys.Very_Low_Psychological_Safety_Description');
		} else if (sum >= 11 && sum <= 20) {
			return this.angularFilterHelperService.translateUnauthenticated('Surveys.Low_Psychological_Safety_Description');
		} else if(sum >= 21 && sum <= 29) {
			return this.angularFilterHelperService.translateUnauthenticated('Surveys.Moderate_To_High_Psychological_Safety_Description');
		} else if(sum >= 30 && sum <= 35) {
			return this.angularFilterHelperService.translateUnauthenticated('Surveys.Very_High_Psychological_Safety_Description');
		}

	}

	displayColorRanges(maxValue, sum, questionnaire) {
	    setTimeout(() => {
	        var container = document.getElementById("container");
	        var sliderContainer = document.querySelector(".s-slider-container");
	        container.style.marginBottom = this.vm.isMultipleQuestionnaire ? '24px' : '-6px';

	        var rangeContainer = document.createElement('div');
	        rangeContainer.style.marginTop = '40px';
	        var label = document.createElement('div');
	        label.classList.add('s-slider-label');
			const codeName = questionnaire.codeName;

			// Create a range input element
			var colorRange = document.createElement('input');
			colorRange.max = maxValue;
			colorRange.type = 'range';
			var percentage;
			if (codeName === 'DOM-SAFETY') {
				colorRange.min = '7';
				colorRange.classList.add('s-slider-reverse');
				percentage = (sum * 100) / maxValue - 10;
			} else {
				colorRange.min = '0';
				colorRange.classList.add('s-slider');
				percentage = (sum * 100) / maxValue;
			}

			label.textContent = this.getLabel(percentage);
			colorRange.disabled = true;
			colorRange.style.marginTop = this.vm.isMultipleQuestionnaire ? '40px' : '0px';
			colorRange.value = sum;
			rangeContainer.appendChild(colorRange);
			sliderContainer.appendChild(rangeContainer);

			var rect = colorRange.getBoundingClientRect();
			label.style.left = "calc(" + (percentage + "%") + ")";
			label.style.top = this.vm.isMultipleQuestionnaire ? rect.top - 360 + 'px' : '-24px';
			rangeContainer.appendChild(label);

	    }, 500);
	}

	displayEvaluations(evaluationText, questionnaire, sum) {
	    setTimeout(() => {
	        var container = document.querySelector("#evaluationContainer");
	        var titleTag = document.createElement('p');
	        titleTag.classList.add('c-text');
	        titleTag.classList.add('c-text--bold');
	        titleTag.style.fontSize = '18px';
			titleTag.innerHTML = this.getDisplayTextForTranslatable(questionnaire) + "</br>";
	        titleTag.style.marginTop = '12px';

	        var label = document.createElement('p');
	        if (!this.vm.isMultipleQuestionnaire) {
	            label.classList.add('c-text--center');
	            titleTag.classList.add('c-text--center');
	        }
			const codeName = questionnaire.codeName;

			if (codeName === 'DOM-SAFETY') {
				var translatedText = this.getEvaluationsForSafetySurvey(sum);
				label.textContent = translatedText.length > 200 ? translatedText.slice(0, 200) : translatedText;
				if (translatedText.length > 200) {
					const ellipsisSpan = document.createElement('span');
					ellipsisSpan.textContent = '...';
					label.appendChild(ellipsisSpan);
				}
				const readMoreLink = document.createElement('a');
				readMoreLink.classList.add('c-text', 'c-text--s19');
				readMoreLink.href = 'javascript:void(0);';
				readMoreLink.textContent = this.angularFilterHelperService.translateUnauthenticated('Services.Button.Read_More');

				readMoreLink.addEventListener('click', () => {
					this.vm.openFullDescription(sum);
				});
				label.appendChild(readMoreLink);
			} else {
				label.textContent = evaluationText;
			}
	        label.style.marginTop = '18px';
	        container.appendChild(titleTag);
	        container.appendChild(label);
	    }, 500);
	}

	openFullDescription(sum) {
		this.dialogServices.show({
			controller: ModalSafetyResultsIndividualComponent,
			score: sum,
			width: '500px',
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
	}
}
